import React, { useMemo } from 'react';
import { ComposableDevicesManagerStoreInfoResponse } from '../../../../../service/device/hooks/useDevicesManager';
import { ComposableDevicesStoreInfoResponse } from '../../../../../service/store/hooks/useDevicesWithComposableDevice';
import { GetWifiSignalIcon } from '../../../../../shared/util/rssi/getIcon';
import { Box, CircularProgress } from '@mui/material';
import { useGetCurrentSensorInformation } from '../../../../../redux/controlUnit/hooks/useGetCurrentSensorInformation';
import { useControlUnitsByBusAddress } from '../../../../../redux/controlUnit/hooks/useControlUnitsByBusAddress';
import { isNotNullOrUndefined } from '../../../../../shared/util/collection/isNotNullOrUndefined';

interface RSSIOverviewByDeviceProps {
  device:
    | ComposableDevicesStoreInfoResponse
    | ComposableDevicesManagerStoreInfoResponse;
}
export const RSSIOverviewByDevice = (props: RSSIOverviewByDeviceProps) => {
  const { device } = props;

  const commanderId = device?.commanderId;

  const { sensorData, loading, error } = useGetCurrentSensorInformation({
    commanderId: commanderId,
  });

  const { controlUnitsByBusAddress } = useControlUnitsByBusAddress(device);

  const RSSIValue = useMemo(() => {
    if (!sensorData) return null;
    // Sensor data is keyed by cuid (backend boundary), so resolve the cuids for
    // this device's control units from the bus-address structure.
    const controlUnitIds = new Set(
      Object.values(controlUnitsByBusAddress)
        .map((controlUnit) => controlUnit.controlUnitId)
        .filter(isNotNullOrUndefined)
    );
    return sensorData.find(
      (data) => data.channel === 'RSSI' && controlUnitIds.has(`${data.cuId}`)
    )?.value;
  }, [controlUnitsByBusAddress, sensorData]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {loading ? (
        <CircularProgress style={{ height: '1.5rem', width: '1.5rem' }} />
      ) : (
        <GetWifiSignalIcon rssi={error ? null : RSSIValue} width={'2rem'} />
      )}
    </Box>
  );
};
